/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { customersGenerateBillingLinks } from "../../funcs/customersGenerateBillingLinks.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.CreateCustomerPortalLinkRequestEntity$inboundSchema,
};

export const tool$customersGenerateBillingLinks: ToolDefinition<typeof args> = {
  name: "customers-generate-billing-links",
  description: `Generate Customer Links

Generate a customer portal link for managing billing, subscriptions, and payment methods.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await customersGenerateBillingLinks(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
